import { useState, useEffect } from 'react';
import { blogDb, BLOG_ID } from '@/integrations/supabase/client';

export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readingTime: string;
  image: string | null;
  content: string;
  tags: string[] | null;
}

export const useBlogPosts = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      const { data, error } = await blogDb
        .from('posts')
        .select('slug, title, excerpt, category, date, reading_time, image, content, tags')
        .eq('blog_id', BLOG_ID)
        .eq('status', 'published')
        .order('created_at', { ascending: false });

      if (!error && data) {
        setPosts(data.map(p => ({
          slug: p.slug,
          title: p.title,
          excerpt: p.excerpt,
          category: p.category,
          date: p.date,
          readingTime: p.reading_time,
          image: p.image,
          content: p.content,
          tags: p.tags,
        })));
      }
      setLoading(false);
    };
    fetchPosts();
  }, []);

  return { posts, loading };
};
